<div class="decks-wrapper">
    <mat-card class="deck mat-elevation-z4" *ngFor="let deck of decks">
        <mat-card-header>
            <mat-card-title>{{deck.name}}</mat-card-title>
            <mat-card-subtitle>{{deck.format}}</mat-card-subtitle>
            <span class="spacer"></span>
            <button mat-icon-button [color]="viewButtonColor" (click)="toggleLikeDeck(deck.id)" matTooltip="Likes" gtagEvent trackOn="click" action="upvote_Deck" category="decks">
                <mat-icon [innerHTML]="getLikeIconName(deck)"></mat-icon> {{deck.upvoteCount}}
            </button>
            <button mat-icon-button [color]="viewButtonColor" [routerLink]="getRouterLink(deck.id)" gtagEvent trackOn="click" action="view_deck" category="decks" matTooltip="View Deck">
                <mat-icon>visibility</mat-icon>
            </button>
            <button *ngIf="shouldShowDeleteButton(deck)" mat-icon-button [color]="viewButtonColor" (click)="confirmDeleteDeck(deck.id)" gtagEvent trackOn="click" action="delete_deck" category="decks" matTooltip="Delete Deck">
                <mat-icon>delete</mat-icon>
            </button>
        </mat-card-header>
        <div class="card-image" [style.width]="'100%'">
            <app-card-image [style.cursor]="'pointer'" [width]="225" [card]="getFocusedCard(deck.id) | async" [draggable]="false" [clickable]="false" [routerLink]="getRouterLink(deck.id)" gtagEvent trackOn="click" action="view_deck_via_image" category="decks" matTooltip="View Deck"></app-card-image>
            <div class="charts-wrapper" gtagEvent trackOn="mouseenter" action="hover_mini_charts" category="decks">
                <app-small-line-chart title="CMC" [xMax]="10"
                                      [data]="getCmcCurve(deck.id) | async"></app-small-line-chart>
                <br>
                <app-small-pie-chart title="Colors" [data]="getColorDistro(deck.id) | async"
                                     [sectionLabels]="['White', 'Blue', 'Black', 'Red', 'Green', 'Colorless']"
                                     [sectionColors]="['#f2eeca', '#aae1fa', '#cac0be', '#f5a78d', '#96cda9', '#c7d4f2']"></app-small-pie-chart>
            </div>
        </div>
        <mat-card-content [style.display]="'flex'">
            <span>By {{deck.owner.alias}}</span>
            <span class="spacer"></span>
            <span>Cards: {{getDeckCardCount(deck.id)}}</span>
        </mat-card-content>
    </mat-card>
    <mat-card *ngIf="add" (click)="addClicked.emit()" class="deck mat-elevation-z4" [style.cursor]="'pointer'">
        <mat-card-content class="add-deck">
            <mat-icon>add</mat-icon>
            <h2>Add Deck</h2>
        </mat-card-content>
    </mat-card>
</div>
